module.exports = __webpack_public_path__ + "static/condo_currentPage-96f7b5deda5617e164f5c870376fd45a.jpg";